export default  {	
	data () {
		return { 
			filter: {
				name: null,
				id_list: null,
				id_datos_razon: null,
				id_datos_asesor: null,
				id_datos_contacto: null,
			},
			mes: null,
			ano: null,
			statusDescargar:false,			
			statusLoading: false
		}
	},
	async created () { 
		// solo frontend this.searchGetIdb({tabla:'afiliacion_registro'})
		this.mes= this.gettersDatalist('list_mes',this.fecha().fecha.mesHoy)[0]
		this.ano= this.gettersDatalist('list_ano',this.fecha().fecha.anoHoy)[0]
	},		
	computed: 
	{
		
	},
	destroyed()
	{
		this.resetCrud({state: 'dataGet/informes_aportes/data'})
	}
}
